import { useContext } from 'react';
import AuthContext from 'contexts/JWTContext';

export default function useAuth() {
  const context = useContext(AuthContext);

  if (!context) throw new Error('context must be use inside provider');

  const origLogin = context.login;

  return {
    ...context,
    login: async (email, password, tenant) => {
      try {
        const result = await origLogin(email, password, tenant);
        return result;
      } catch (err) {
        let detail;
        if (err?.response && err.response.data) {
          detail = err.response.data.detail || err.response.data.message;
        }
        if (!detail && err?.detail) detail = err.detail;
        if (!detail && err?.message) detail = err.message;
        if (!detail) detail = "Erro ao autenticar. Verifique login, senha ou cliente.";
        const wrappedErr = new Error(detail);
        wrappedErr.detail = detail;
        throw wrappedErr;
      }
    }
  };
}